import React, {useState, useEffect} from 'react';
import Api_UsuarioPoliza from '../../Api/Api_UsuarioPoliza.js';
import Api_UsuarioLogin from '../../Api/Api_UsuarioLogin.js';

function Login (props) {
   const frmUsuario = {user:'', cuit: '', psw:'', nombre: ''};
   const [usuario, setUsuario] = useState(frmUsuario);
   const [showMessage, setShowMessage] = useState(false);
   const [showMessage2, setShowMessage2] = useState(false);
   


   const handleChange = e => { 
		const {name,value} = e.target;
		setUsuario({...usuario,[name]:value}); 
   };

   useEffect(() => {
	window.scrollTo(0, 0)
   }, [])


	const setMsj1 = (usuario) => {
		setShowMessage(true)
		setShowMessage2(false)

		console.log('usuario_setMsj1()',usuario)
		props.usuarioLogueado(usuario)

		//props.Usuarios(1)

		/* //consulto la poliza del usuario
		console.log("usuario.user: "+usuario.user);
		console.log("usuario.psw: "+usuario.psw);
		Api_UsuarioPoliza(1)
        .then((response) => {
            if (response.data){
				
				const user = response.data;
				
				//const userCUIT = (response.data.Tipo === "T" ? response.data.UsuarioWebEmpresas[0].CUIT : usuario.cuit);				

				frmUsuario.usuario = JSON.stringify(user.Nombre);
				frmUsuario.psw = '';

				setUsuario(frmUsuario);
				setShowMessage(true);
				setShowMessage2(false);
 
				//props.usuarioLogueado(response.data, userCUIT)
				console.log('Login:', response.status, response.data);
			}else{
				console.log('ERROR!', response.status, response.data);
				frmUsuario.usuario = 'vacio';
				setUsuario(frmUsuario);
				setShowMessage(false);
				setShowMessage2(true);
			}	
        },
        (error) => {
           console.log('error: '+error);
        }) */
	};

	const setMsj2 = () => {
			setShowMessage(false);
			setShowMessage2(true);
		};

   const handleLogin = async e =>{
	    e.preventDefault();

		require('dotenv').config();

		//{usuario.user === 'ciro@binarianet.com' && usuario.psw === 'binaria' ? setMsj1() : setMsj2()}

		let cuit_psw = {CUIT: '', Password: ''}; //declaro la variable que enviaré como body en la query

		cuit_psw.CUIT = usuario.user;
		cuit_psw.Password = usuario.psw;
		
		await Api_UsuarioLogin(cuit_psw)
        .then((response) => {
            if (response.data){
				
				const user = response.data;
				
				console.log('Login:', response.status, user);
				setMsj1(user)

				/*
				const userCUIT = (response.data.Tipo === "T" ? response.data.UsuarioWebEmpresas[0].CUIT : usuario.cuit);				

				frmUsuario.usuario = JSON.stringify(user.Nombre);
				frmUsuario.psw = '';

				setUsuario(frmUsuario);
				setShowMessage(true);
				setShowMessage2(false);
 
				props.usuarioLogueado(response.data, userCUIT)
				console.log('Login:', response.status, response.data);*/

			}else{

				//setMsj2()

				console.log('ERROR!', response.status, response.data);
				frmUsuario.usuario = 'vacio';
				setUsuario(frmUsuario);
				setShowMessage(false);
				setShowMessage2(true);
			}	
        },
        (error) => {
           console.log('error: '+error);
        })
   }

  return (
		<>
		<div className="container pt-2 text-center">

		
            {/*<div style={{color: 'rgb(150, 152, 154)'}}>
                  <h2 
                  style={{'font-weight': 'bold'}}
                  >Acceso Usuario</h2>
            </div>*/}

			<div className="alert alert-light" role="alert">
				
			</div>
			
			{ showMessage2 ? <div className="alert alert-success col-md-7 mx-auto" role="alert">Error al ingresar los datos! Verifique CUIT/CUIL y Contraseña </div> : ``}

			<form onSubmit={handleLogin} style={{color: 'rgb(150, 152, 154)'}}>
				
				<div className="pt-3 row col-md-7 mx-auto">
						<div className="text-left mx-auto"> <b>CUIT/CUIL:</b> <br/>
							<input value={usuario.user} required type="text" name="user" onChange={handleChange}  className="input-group form-control" placeholder="CUIT/CUIL" />
						</div>
				</div>

				<div className="pt-3 row col-md-7 mx-auto">
					<div className="text-left mx-auto"> <b>Contraseña:</b> <br/>
						<input value={usuario.contraseña} required type="password" name="psw" onChange={handleChange}  className="input-group form-control" placeholder="Contraseña" />
					</div>
				</div>

				<div className="pt-3 mx-auto text-center">
					<button className="btn btn-primary btn-enviar">Ingresar</button>
				</div>
			</form>	
		</div>
	</>
  );
}
export default Login;
